export default __webpack_public_path__ + "static/media/error-table-icon.39ae2663.svg";